// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-over-time-chart {
  font-family: Arial, sans-serif;
  background-color: #ffffff;
  border-radius: 8px;
  margin: 0 auto;
  width: calc(100% - 40px);
  max-width: 1250px;
}

.change-over-time-chart h2 {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
  text-align: left;
}

.chart-controls {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 20px;
  margin-bottom: 20px;
}

.control-group {
  display: flex;
  flex-direction: column;
  width: calc(33.33% - 20px);
  min-width: 200px;
}

.control-group label {
  margin-bottom: 5px;
  font-weight: bold;
}

.control-group input[type="range"],
.control-group select {
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

.control-group input[type="range"] {
  -webkit-appearance: none;
  height: 10px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  transition: opacity .2s;
}

.control-group input[type="range"]:hover {
  opacity: 1;
}

.control-group input[type="range"]::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  background: #4CAF50;
  cursor: pointer;
  border-radius: 50%;
}

.control-group input[type="range"]::-moz-range-thumb {
  width: 20px;
  height: 20px;
  background: #4CAF50;
  cursor: pointer;
  border-radius: 50%;
}

.chart-container {
  width: 100%;
  max-width: 1250px;
  margin: 0 auto;
  overflow-x: auto; /* Allow horizontal scrolling on small screens */
  position: relative;
}

.chart-container svg {
  width: 100%;
  min-width: 300px; /* Ensure a minimum width for the chart */
  height: auto;
}

circle {
  cursor: pointer;
}
/* This hover effect is likely not working as intended for SVG circles.
   SVG circles use 'r' attribute, not CSS 'r' property.
   Consider using JavaScript to modify the 'r' attribute on hover instead. */
circle:hover {
  /* r: 8; */
  fill-opacity: 0.8; /* Alternative hover effect */
}

.diff-bar {
  opacity: 0.8;
}

.diff-bar:hover {
  opacity: 1;
}

.diff-label {
  pointer-events: none;
}

.image-group {
  cursor: pointer;
  pointer-events: all;
  display: flex;
  align-items: center;
}

.image-container {
  pointer-events: none;
}

.image-border {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.image-border img {
  pointer-events: all;
  cursor: pointer;
}

.image-label {
  pointer-events: none;
  font-size: 12px;
  fill: #333;
  -webkit-user-select: none;
          user-select: none;
}

/* Ensure no hover effects */
.image-group,
.image-group *,
.image-group:hover,
.image-group:hover * {
  transition: none !important;
  transform: none !important;
}

.gridlines line {
  pointer-events: none;
}

.search-results {
  margin-top: 20px;
}

.search-results ul {
  list-style-type: none;
  padding: 0;
}

.search-results li {
  margin-bottom: 10px;
}

.search-results button {
  margin-left: 10px;
}

.search-section {
  margin-top: 20px;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 8px;
}

.search-section h3 {
  margin-bottom: 10px;
}

.search-section input[type="text"] {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.search-results {
  list-style-type: none;
  padding: 0;
  margin-top: 10px;
  max-height: 200px;
  overflow-y: auto;
}

.search-results li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #fff;
  border: 1px solid #ddd;
  margin-bottom: 5px;
  border-radius: 4px;
}

.search-results li.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.search-results button {
  padding: 5px 10px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}

.search-results button:hover {
  background-color: #45a049;
}

.error-message {
  font-size: 12px;
  color: #f44336;
  margin-left: 10px;
}

@media (max-width: 768px) {
  .change-over-time-chart h2 {
    font-size: 20px;
  }

  .chart-controls {
    flex-direction: column;
    align-items: center;
  }

  .control-group {
    width: 100%;
    max-width: 300px;
  }

  .control-group input[type="range"] {
    width: 100%;
  }

  .search-section input[type="text"] {
    font-size: 14px;
  }

  .search-results li {
    flex-direction: column;
    align-items: flex-start;
  }

  .search-results button,
  .error-message {
    margin-top: 5px;
    margin-left: 0;
  }
}

.error-message,
.no-data-message {
  text-align: center;
  padding: 20px;
  font-size: 16px;
  color: #721c24;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  margin-top: 20px;
}

.no-data-message {
  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb;
}

.year-range-slider {
  width: 300px;
  margin: 10px 0;
}

.year-range-slider .track {
  stroke: #ddd;
  stroke-width: 10px;
  stroke-linecap: round;
}

.year-range-slider .selected-range {
  stroke: #4CAF50;
  stroke-width: 10px;
  stroke-linecap: round;
}

.year-range-slider .handle {
  fill: #4CAF50;
  stroke: #fff;
  stroke-width: 3px;
  cursor: ew-resize;
}

.year-range-slider .label {
  font-size: 12px;
  fill: #333;
}`, "",{"version":3,"sources":["webpack://./src/components/ChangeOverTimeChart/style.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,gBAAgB,EAAE,gDAAgD;EAClE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,yCAAyC;EAC3D,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;AACA;;4EAE4E;AAC5E;EACE,UAAU;EACV,iBAAiB,EAAE,6BAA6B;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;;;;EAIE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ","sourcesContent":[".change-over-time-chart {\n  font-family: Arial, sans-serif;\n  background-color: #ffffff;\n  border-radius: 8px;\n  margin: 0 auto;\n  width: calc(100% - 40px);\n  max-width: 1250px;\n}\n\n.change-over-time-chart h2 {\n  font-size: 24px;\n  color: #333;\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.chart-controls {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.control-group {\n  display: flex;\n  flex-direction: column;\n  width: calc(33.33% - 20px);\n  min-width: 200px;\n}\n\n.control-group label {\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\n.control-group input[type=\"range\"],\n.control-group select {\n  width: 100%;\n  padding: 5px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.control-group input[type=\"range\"] {\n  -webkit-appearance: none;\n  height: 10px;\n  background: #d3d3d3;\n  outline: none;\n  opacity: 0.7;\n  transition: opacity .2s;\n}\n\n.control-group input[type=\"range\"]:hover {\n  opacity: 1;\n}\n\n.control-group input[type=\"range\"]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  background: #4CAF50;\n  cursor: pointer;\n  border-radius: 50%;\n}\n\n.control-group input[type=\"range\"]::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  background: #4CAF50;\n  cursor: pointer;\n  border-radius: 50%;\n}\n\n.chart-container {\n  width: 100%;\n  max-width: 1250px;\n  margin: 0 auto;\n  overflow-x: auto; /* Allow horizontal scrolling on small screens */\n  position: relative;\n}\n\n.chart-container svg {\n  width: 100%;\n  min-width: 300px; /* Ensure a minimum width for the chart */\n  height: auto;\n}\n\ncircle {\n  cursor: pointer;\n}\n/* This hover effect is likely not working as intended for SVG circles.\n   SVG circles use 'r' attribute, not CSS 'r' property.\n   Consider using JavaScript to modify the 'r' attribute on hover instead. */\ncircle:hover {\n  /* r: 8; */\n  fill-opacity: 0.8; /* Alternative hover effect */\n}\n\n.diff-bar {\n  opacity: 0.8;\n}\n\n.diff-bar:hover {\n  opacity: 1;\n}\n\n.diff-label {\n  pointer-events: none;\n}\n\n.image-group {\n  cursor: pointer;\n  pointer-events: all;\n  display: flex;\n  align-items: center;\n}\n\n.image-container {\n  pointer-events: none;\n}\n\n.image-border {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.image-border img {\n  pointer-events: all;\n  cursor: pointer;\n}\n\n.image-label {\n  pointer-events: none;\n  font-size: 12px;\n  fill: #333;\n  user-select: none;\n}\n\n/* Ensure no hover effects */\n.image-group,\n.image-group *,\n.image-group:hover,\n.image-group:hover * {\n  transition: none !important;\n  transform: none !important;\n}\n\n.gridlines line {\n  pointer-events: none;\n}\n\n.search-results {\n  margin-top: 20px;\n}\n\n.search-results ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.search-results li {\n  margin-bottom: 10px;\n}\n\n.search-results button {\n  margin-left: 10px;\n}\n\n.search-section {\n  margin-top: 20px;\n  padding: 20px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n}\n\n.search-section h3 {\n  margin-bottom: 10px;\n}\n\n.search-section input[type=\"text\"] {\n  width: 100%;\n  padding: 10px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.search-results {\n  list-style-type: none;\n  padding: 0;\n  margin-top: 10px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.search-results li {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  margin-bottom: 5px;\n  border-radius: 4px;\n}\n\n.search-results li.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.search-results button {\n  padding: 5px 10px;\n  background-color: #4CAF50;\n  color: white;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n}\n\n.search-results button:hover {\n  background-color: #45a049;\n}\n\n.error-message {\n  font-size: 12px;\n  color: #f44336;\n  margin-left: 10px;\n}\n\n@media (max-width: 768px) {\n  .change-over-time-chart h2 {\n    font-size: 20px;\n  }\n\n  .chart-controls {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .control-group {\n    width: 100%;\n    max-width: 300px;\n  }\n\n  .control-group input[type=\"range\"] {\n    width: 100%;\n  }\n\n  .search-section input[type=\"text\"] {\n    font-size: 14px;\n  }\n\n  .search-results li {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .search-results button,\n  .error-message {\n    margin-top: 5px;\n    margin-left: 0;\n  }\n}\n\n.error-message,\n.no-data-message {\n  text-align: center;\n  padding: 20px;\n  font-size: 16px;\n  color: #721c24;\n  background-color: #f8d7da;\n  border: 1px solid #f5c6cb;\n  border-radius: 4px;\n  margin-top: 20px;\n}\n\n.no-data-message {\n  color: #0c5460;\n  background-color: #d1ecf1;\n  border-color: #bee5eb;\n}\n\n.year-range-slider {\n  width: 300px;\n  margin: 10px 0;\n}\n\n.year-range-slider .track {\n  stroke: #ddd;\n  stroke-width: 10px;\n  stroke-linecap: round;\n}\n\n.year-range-slider .selected-range {\n  stroke: #4CAF50;\n  stroke-width: 10px;\n  stroke-linecap: round;\n}\n\n.year-range-slider .handle {\n  fill: #4CAF50;\n  stroke: #fff;\n  stroke-width: 3px;\n  cursor: ew-resize;\n}\n\n.year-range-slider .label {\n  font-size: 12px;\n  fill: #333;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
